import { Modal } from '@app/react-common';
import { ModalBody } from '@app/react-common/Modal';
import { Button, theme } from 'components';
import React from 'react';
import styled from 'styled-components';

const LockboxPhotoModal = ({ lockboxPhoto, showModal, closeModal }: any) => (
    <>
      <Modal size={100} width="200px" show={showModal} onHide={closeModal}>
        <ModalBody width="200px">
          <StyledImage src={lockboxPhoto} />
          <FlexContainer>
            <Button onClick={closeModal}>Close</Button>
          </FlexContainer>
        </ModalBody>
      </Modal>
    </>
  );

export default LockboxPhotoModal;

const StyledImage = styled.img`
  height: 400px;
  width: 100%;
`;

const FlexContainer = styled.div`
  margin-top: 20px;
  border-top: 1px solid ${theme.gray4};
  padding: 10px;
  display: flex;
  justify-content: flex-end;
`;
